/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  GetTransactionsSettlementsOptions,
  GetTransactionsSettlementsStatus200,
  GetTransactionsSettlementsStatus400,
  GetTransactionsSettlementsStatus404,
  GetTransactionsSettlementsStatus500,
} from '../types/GetTransactionsSettlements'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { getTransactionsSettlements } from '../clients/getTransactionsSettlements'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getTransactionsSettlementsQueryKey = ({
  query,
}: Omit<GetTransactionsSettlementsOptions, 'headers'> = {}) =>
  [{ url: '/v1/transactions/settlements' }, ...(query ? [query] : [])] as const

type GetTransactionsSettlementsQueryKey = ReturnType<typeof getTransactionsSettlementsQueryKey>

export function getTransactionsSettlementsQueryOptions(
  { query }: GetTransactionsSettlementsOptions = {},
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const queryKey = getTransactionsSettlementsQueryKey({ query })
  return queryOptions<
    GetTransactionsSettlementsStatus200,
    ResponseErrorConfig<
      | GetTransactionsSettlementsStatus400
      | GetTransactionsSettlementsStatus404
      | GetTransactionsSettlementsStatus500
    >,
    GetTransactionsSettlementsStatus200,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getTransactionsSettlements({
        ...config,
        query,
        signal: config.signal ?? signal,
        throwOnError: true,
      }).unwrap()
    },
  })
}

/**
 * @summary Get transactions settlements with filters
 * {@link /v1/transactions/settlements}
 */
export function useGetTransactionsSettlements<
  TData = GetTransactionsSettlementsStatus200,
  TQueryData = GetTransactionsSettlementsStatus200,
  TQueryKey extends QueryKey = GetTransactionsSettlementsQueryKey,
>(
  {
    query,
  }: {
    query?:
      | GetTransactionsSettlementsOptions['query']
      | (() => GetTransactionsSettlementsOptions['query'])
  } = {},
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetTransactionsSettlementsStatus200,
        ResponseErrorConfig<
          | GetTransactionsSettlementsStatus400
          | GetTransactionsSettlementsStatus404
          | GetTransactionsSettlementsStatus500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const resolvedParams = { query: typeof query === 'function' ? query() : query }
  const queryKey = resolvedOptions?.queryKey ?? getTransactionsSettlementsQueryKey(resolvedParams)

  const queryResult = useQuery(
    {
      ...getTransactionsSettlementsQueryOptions(resolvedParams, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetTransactionsSettlementsStatus400
      | GetTransactionsSettlementsStatus404
      | GetTransactionsSettlementsStatus500
    >
  > & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
